import addModal from './addModal.vue';
import { columns } from './utils';
import { insuranceClassList, insuranceClassUpdate, insuranceClassDelete, insuranceClassDetail } from './request';
export default {
  components: {
    addModal
  },
  data() {
    return {
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      columns,
      form: {
        name: ''
      },
      tableData: [],
      expandedRowKeys: [],
      selectedRowKeys: []
    };
  },
  created() {
    this.searchFun();
  },
  methods: {
    searchFun() {
      this.pagination.current = this.pagination.page = 1;
      this.getListData();
    },
    async getListData() {
      const {
        items,
        totalNum
      } = await insuranceClassList(Object.assign(this.form, {
        page: this.pagination.page,
        pageSize: this.pagination.pageSize
      }));
      this.tableData = items;
      this.pagination.total = totalNum;
      let lastPage = Math.ceil(this.pagination.total / this.pagination.pageSize);
      if (this.pagination.page === lastPage + 1 && this.pagination.total % (this.pagination.pageSize * (this.pagination.page - 1)) === 0) {
        this.pagination.page -= 1;
        this.pagination.current -= 1;
        this.getListData();
      }
    },
    tablePageChange(val) {
      this.pagination = val;
      this.pagination.page = val.current;
      this.getListData();
    },
    onAdd() {
      this.$refs.addRef.openModal('add');
    },
    async onEdit(id) {
      const res = await insuranceClassDetail({
        insuranceSortId: id
      });
      this.$refs.addRef.openModal('edit', res);
    },
    // 批量删除
    async batchDelete() {
      if (this.selectedRowKeys.length) {
        await this.onDelete(this.selectedRowKeys);
        this.selectedRowKeys = [];
      } else {
        this.$message.error(this.$t('请选择') + this.$t('要删除的数据'));
      }
    },
    async onDelete(id) {
      await this.$alert(this.$t('是否确认删除') + '?', {
        confirmButtonText: this.$t('确定')
      });
      await insuranceClassDelete({
        insuranceSortId: Array.isArray(id) ? id : [id]
      });
      this.$message.success(this.$t('删除成功') + '!');
      this.getListData();
    },
    async checkedStatus(checked, id) {
      await insuranceClassUpdate({
        insuranceSortId: id,
        status: checked ? 1 : 0
      });
      this.$message.success(this.$t('保存成功') + '!');
      this.getListData();
    },
    isChecked(text) {
      return text;
    },
    onSelectChange(val) {
      this.selectedRowKeys = val;
    }
  }
};